<router-outlet></router-outlet>
<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->
<ngx-spinner size="default" color="#94D0E8" type="timer" [fullScreen]="true">
    <p style="color: white">{{'app_spinner_text'| translate}}</p>
</ngx-spinner>
<p-toast position="bottom-center"></p-toast>
<!-- <p-messages></p-messages> -->
<!-- <div class="flex justify-content-center">
    <p-messages></p-messages>
</div> -->